import { styled, Card as MuiCard, alpha } from '@mui/material';

type CustomProps = {
  isMobile: boolean;
};

export const Card = styled(MuiCard, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<CustomProps>(({ theme, isMobile }) => ({
  borderColor: alpha(theme.newPalette.grey.grey500, 0.32),
  borderRadius: '16px',
  width: isMobile ? '100%' : '250px',
  minHeight: isMobile ? 'auto' : '150px',
  padding: '16px',
  textAlign: 'center',
}));
